import PDFButtonBase from '@/components/PDFButton/Base.vue';
import api from '@/api';

export default {
  mixins: [
    PDFButtonBase,
  ],
  props: {
    transactionId: {
      type: Number,
      default: null,
    },
  },
  methods: {
    fetchPDF() {
      return api.resource.rafPayoutConfirmation(this.transactionId);
    },
  },
};
